module.exports = __webpack_public_path__ + "img/Vinje_Kulturformidling_og_underholdning.92ed8720.jpg";